exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".confirmation-content .databaseName,.confirmation-content .imageLocation,.confirmation-content .imageSize,.confirmation-content .serverName{font-size:1em;color:#373737}.confirmation-content h3{margin:0 0 1.5em}.confirmation-content h4{color:#373737}.confirmation-content li{margin:.5em 0}.confirmation-content .confirm-row{border-bottom:1px solid #d3d3d3;padding:.5em 0}.confirmation-content .edit{text-align:right;text-transform:uppercase;color:#3c85df;font-weight:600;letter-spacing:.05em;font-size:.85em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/confirmation-page.scss
// module id = 1026
// module chunks = 0